export default "__VITE_ASSET__66c6ef64__"